// Links to Backbone Content Library
// TODO: Add es and nl version
export enum ContentLibraryLinks {
  EN = 'https://bkbn.com/en/content-library',
  FR = 'https://bkbn.com/fr/content-library',
  DE = 'https://bkbn.com/de/content-library',
  ES = 'https://bkbn.com/es/content-library/',
  GENERAL = 'https://bkbn.com/content-library',
}